function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "24 / grid / edit-shape"
}, /*#__PURE__*/React.createElement("path", {
  id: "icon",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M23 19C23 17.6938 22.1652 16.5825 21 16.1707V7.82929C22.1652 7.41746 23 6.30622 23 5C23 3.34315 21.6569 2 20 2C18.6938 2 17.5825 2.83481 17.1707 4H6.82929C6.41746 2.83481 5.30622 2 4 2C2.34315 2 1 3.34315 1 5C1 6.30622 1.83481 7.41746 3 7.82929V16.1707C1.83481 16.5825 1 17.6938 1 19C1 20.6569 2.34315 22 4 22C5.30622 22 6.41746 21.1652 6.82929 20H17.1707C17.5825 21.1652 18.6938 22 20 22C21.6569 22 23 20.6569 23 19ZM19 7.82929V16.1707C18.1476 16.472 17.472 17.1476 17.1707 18H6.82929C6.52801 17.1476 5.85241 16.472 5 16.1707V7.82929C5.85241 7.52801 6.52801 6.85241 6.82929 6H17.1707C17.472 6.85241 18.1476 7.52801 19 7.82929ZM4 6C4.55228 6 5 5.55228 5 5C5 4.44772 4.55228 4 4 4C3.44772 4 3 4.44772 3 5C3 5.55228 3.44772 6 4 6ZM21 5C21 5.55228 20.5523 6 20 6C19.4477 6 19 5.55228 19 5C19 4.44772 19.4477 4 20 4C20.5523 4 21 4.44772 21 5ZM4 20C4.55228 20 5 19.5523 5 19C5 18.4477 4.55228 18 4 18C3.44772 18 3 18.4477 3 19C3 19.5523 3.44772 20 4 20ZM21 19C21 19.5523 20.5523 20 20 20C19.4477 20 19 19.5523 19 19C19 18.4477 19.4477 18 20 18C20.5523 18 21 18.4477 21 19Z",
  fill: "white"
}));

var SvgRedoIcon = function SvgRedoIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRedoIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/redo-icon.4591d193.svg";
export { ForwardRef as ReactComponent };